import React from 'react';
export function Footer() {
  return <footer className="bg-[#1A1A1A] text-white py-12 border-t border-gray-800" data-id="element-158">
      <div className="container mx-auto px-4 text-center" data-id="element-159">
        <p className="font-serif text-xl font-bold mb-6 text-[#D8F3DC]" data-id="element-160">
          Rodilla Sin Miedo
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-sm text-gray-400 mb-8" data-id="element-161">
          <a href="#" className="hover:text-white transition-colors" data-id="element-162">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-163">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-164">
            Contacto
          </a>
        </div>

        <p className="text-xs text-gray-600 max-w-lg mx-auto leading-relaxed" data-id="element-165">
          Este producto no sustituye el consejo médico profesional. Si tenés una
          lesión aguda o dolor severo, consultá a tu médico antes de comenzar
          cualquier programa de ejercicios.
        </p>

        <p className="mt-8 text-xs text-gray-600" data-id="element-166">
          © {new Date().getFullYear()} Rodilla Sin Miedo. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}